export const currencies = [
  { label: "USD", value: "USD" },
  { label: "MXN", value: "MXN" }
];
